import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd} from '@angular/router';
import { User } from '../models';
import { UserService, ContextService } from '../services';


@Component({
  selector: 'layout-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  private area: string;
  constructor(
    private router: Router, 
    private userService: UserService,
    private contextService: ContextService,
  ) {
    //console.log(this.router.url)


  }
  hideMenu:boolean = false;
  isConnected: boolean = false;
  context_root:string='';
  isToogled:boolean=false;

  ngOnInit() {

    this.checkIfhideMenu()

    this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
          let url =ev.url.split("/");
          this.area = (url[1] && url[1]=='familles') ? 'B2C':'B2B';
          this.contextService.setContext(this.area);
          this.context_root=(this.contextService.getContext()=='B2B')?'':'/familles';
          this.checkIfhideMenu()
        }
          
     });


    
    this.userService.populate();
    //console.log(this.context_root)
    this.userService.isAuthenticated.subscribe(
      (data) => {
         this.isConnected = data;
        this.checkIfhideMenu()

      }
    );

  
  }

  toggleMenu(){
    console.log(this.isToogled);
    this.isToogled=!this.isToogled;
  }


  checkIfhideMenu(){
    let ressourcesUser=[105, 102, 109, 108, 104];
    let typeUtilisateur=Number(sessionStorage.getItem('typeUtilisateur'));
    console.log(ressourcesUser.indexOf(typeUtilisateur))
    
    if(ressourcesUser.indexOf(typeUtilisateur)>=0){
        this.hideMenu=true;
    }else{
        this.hideMenu=false;
    }


  }

}


// WEBPACK FOOTER //
// ./src/app/shared/layout/header.component.ts